import Config from '../../config';
import Model from '../../model/model';
import Module from '../../core/module';
import Schedule from '../../model/schedule';
import Task from '../../model/task';

import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { unixts } from '../../utils/date';
import { beginLock, endLock } from '../../loader';
import { roleuc } from '../../roles';
import { save } from '../../model/task.utils';





const
    POPUP_NEW = 'schedule-template--popup-new',
    POPUP_EDIT = 'schedule-template--popup-edit';

    



export default Module.extend( { 

    template: 'jst/module.schedule.templates.form',

    url() {
        return this.model.id
            ? `schedule/${this.schedule_.id}/template/${this.model.id}`
            : `schedule/${this.schedule_.id}/new-template`;
    },

    open({ schedule, scheduleId, templateTask, templateTaskId, ...otherArgs }) {
        const schedulePromise = schedule
            ? Promise.resolve( schedule ) : Schedule.byId( scheduleId );
        const templateTaskPromise = templateTask
            ? Promise.resolve( templateTask ) : Task.byId( templateTaskId );

        return Promise.all( [schedulePromise, templateTaskPromise ] )
            .then( ([schedule, templateTask]) => 
                this.openSchedule( { schedule, templateTask, ...otherArgs } ) );
    },

    openSchedule({ schedule, templateTask }) {
        if (schedule.get( 'contract' ))
            // will not be sent to server
            templateTask.set( 'contract_id',
                schedule.get( 'contract').id );

        // edit
        if (templateTask.id)
            return this.schedule_ = schedule, this.bind( templateTask );

        // create
        templateTask.capabilities_ = {
            edit: true,
            update_title: true, update_text: true,
            update_type: true, update_priority: true, update_point: true,
            update_deadline: true,
            update_custom_fields: true,
            assign_department: !roleuc.includes( Config.role() ),
            assign_user: !roleuc.includes( Config.role() ),
        };
        
        templateTask.set( 'date', unixts( new Date() ) );

        if (schedule.get( 'cluster' ))
            templateTask.set( 'cluster_id', 
                schedule.get( 'cluster' ).id );

        else if (schedule.get( 'organization' )) {
            const defaultAssigneeId = this.options.organizations.toJSON()
                .filter( org => org.id == schedule.get( 'organization' ).id )
                [0]
                .default_assigned_organization_id;
            templateTask.set( {
                organization_id: schedule.get( 'organization' ).id,
                assigned_organization_id: defaultAssigneeId || undefined
            } );
        }

        const cluster = schedule.get( 'contract' )
            ? schedule.get( 'contract' ).cluster
            : schedule.get( 'cluster' )
                ? schedule.get( 'cluster' )
                : schedule.get( 'organization' )
                    ? schedule.get( 'organization' ).cluster
                    : null; 

        const filteredPriorities = this.options.priorities.toJSON()
            // global schedule -> any priority
            // global priority -> any schedule
            // otherwise match clusters
            .filter( priority => !cluster || !priority.cluster || cluster.id == priority.cluster.id );
        const priorityClusters = hashify( filteredPriorities
            .map( priority => priority.cluster ? priority.cluster.id : - 1) );
        // all priorities belong to the same cluster? 
        // take first priority as default
        const [priority] = Object.keys( priorityClusters ).length === 1
            ? filteredPriorities
            : [];
        
        if (priority)
            templateTask.set( 'priority_id', priority.id );

        return this.schedule_ = schedule, this.bind( templateTask );
    },

    start() {
        this.listenTo( this.model, 'change', 
            () => this.Buttons.render() );
        return this;
    },

    stop() {
        this.stopListening( this.model );
        return this;
    },

    serialize() {
        const { contracts, organizations, 
            types, statuses, priorities, fields,
            serviceObjectMappings, } = this.options;
        const { locationService, } = this.options;

        return {
            schedule: this.schedule_ instanceof Model ? this.schedule_.toJSON() : this.schedule_,
            capabilities: {
                edit: true,
                update_title: true, update_text: true,
                update_type: true, update_priority: true, update_point: true,
                update_deadline: true,
                update_custom_fields: true,
                assign_department: true,
                assign_user: true,
            },
            locationService,
            hasDiff: () => this.TaskForm.hasDiff( { fields: this.options.fields } ),
            contracts: contracts.toJSON(),
            organizations: organizations.toJSON(),
            types: types.toJSON(),
            statuses: statuses.toJSON(),
            priorities: priorities.toJSON(),
            fields: fields.toJSON(),
            serviceObjectMappings,
        };
    },

    events: {

        'click .-save'() {
            const 
                onResolve = (/*schedule*/) => 
                    this.trigger( Module.BACK ),

                onReject = message => {
                    endLock( this );
                    handle( this.TaskForm, error( message ) );
                };

            beginLock( this );

            const { result, messages } = this.TaskForm.validate();
            if (!result)
                return onReject( messages[0] /* [text, field] */ );
            
            return save( this, { contract_id: true } ).then( ({ task }) => 
                    new Schedule( { id: this.schedule_.id } ).patch( {
                        templates: {
                            add: [{ id: task.id }]
                        }
                    } ) )
                .then( onResolve, onReject );
        },

        'click .-close'() {
            this.trigger( Module.BACK );
        },

    },

    [Module.event( 'Map:map:click' )](location) {
        this.model.set( 'location', location );
        this.Map.render();
    },

    [Module.event( 'Map:service-object:choose' )]({ objectId, layerId }) {
        if (this.model)
            this.model.set( {
                service_object_id: objectId,
                service_object_layer_id: layerId
            } );
        // todo .then( () => this.Map.render() );
    },

    [Module.event( 'Map:address:choose' )](attrs) {
        this.model.set( 'location', attrs.coords );
        this.Map.render();
    },
        
}, {

    POPUP_NEW,

    POPUP_EDIT,

} );



// WEBPACK FOOTER //
// ./src/js/module/schedule/templates.form.js